import styled from '@emotion/styled'
import Modal from '../../../common/Modal/Modal'
import { Space } from 'antd'

export const PreviewContainer = styled(Modal)`
  .ant-modal-content {
    margin: 0px;
    border-radius: 0px;
    padding: 0px !important;
  }

  .ant-modal-body {
    padding: 0px !important;
  }

  .ant-modal-header {
    border-radius: 0;
    margin-bottom: 0px !important;
  }
`

export const PreviewRenderHtml = styled.div`
  background: #fff;
  width: 916px; /* 242mm ≈ 916px */
  min-height: 1103px; /* 297mm ≈ 1123px */
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 20px 32px;
  zoom: 0.8;
`

export const LeftSection = styled.div`
  height: 100%;
  padding: 24px;
`

export const RightSection = styled.div`
  height: 100%;
  border-left: 1px solid #e5e5e5;
`

export const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 16px;
  font-family: 'Prompt', sans-serif;
`

export const TextAreaContainer = styled.div`
  .ant-input {
    font-family: 'Prompt', sans-serif;
    border: 1px solid #d9d9d9;

    &:focus,
    &:hover {
      border-color: #40a9ff;
    }
  }

  .ant-input-show-count-suffix {
    color: #8c8c8c;
    font-size: 12px;
  }
`

export const PDFViewerContainer = styled.div`
  width: 100%;
  height: 450px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  overflow: hidden;
  background: #fafafa;
`

export const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 8px;
`

export const PDFPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8c8c8c;
  font-size: 14px;
  font-family: 'Prompt', sans-serif;
  background: #f9f9f9;
  border-radius: 8px;

  div {
    text-align: center;
    padding: 20px;
  }
`

export const PDFControls = styled.div`
  padding: 24px;
  background: #fafafa;
  height: 624px;
  scroll-behavior: auto;
  overflow-y: scroll;
`

export const StyledRight = styled.div`
  width: 56px;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  display: flex;
  cursor: pointer;
`

export const StyledLeft = styled.div`
  width: 56px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: inline-flex;
`

export const StyledToolbar = styled.div`
  width: 100%;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 10px;
  padding-bottom: 10px;
  background: white;
  border-bottom: 1px #e5e5e5 solid;
  justify-content: space-between;
  align-items: center;
  display: inline-flex;
`

export const StyledModal = styled(Modal)`
  width: 100%;
  max-width: 1200px;
  height: 100%;
  max-height: 800px;

  .ant-modal-content {
    border-radius: 12px;
  }

  .ant-modal-body {
    padding: 0px !important;
  }

  .ant-modal-header {
    border-radius: 12px 12px 0 0;
    margin-bottom: 0px !important;
  }
`

export const RenderHtmlWrapper = styled.div<{
  zoom?: number
}>`
  background: #fff;
  width: 916px; /* 242mm ≈ 916px */
  min-height: 1103px; /* 297mm ≈ 1123px */
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 20px 32px;
  zoom: ${(props) => props.zoom || 0.5};
`

export const ZoomLevelStyled = styled(Space)`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #262626;

  p {
    margin: 0;
    color: black;
    font-size: 16px;
    font-family: Prompt;
    font-weight: 400;
    line-height: 20px;
    word-wrap: break-word;
  }
`
